"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDebounce;
var _react = require("react");
// eslint-disable-next-line import/no-extraneous-dependencies

function useDebounce(value, delay) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    // if (handler) clearTimeout(handler);
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value]);
  return debouncedValue;
}